import { Loader2, Inbox, AlertTriangle } from "lucide-react";

export function LoadingState({ label = "Loading…", testid = "loading-state" }) {
  return (
    <div data-testid={testid} className="flex flex-col items-center justify-center gap-3 rounded-3xl border border-white/50 bg-[#FFFAF1]/80 py-16 text-[#516259] shadow-sm backdrop-blur">
      <Loader2 className="h-6 w-6 animate-spin text-[#2D7A65]" />
      <p className="text-sm">{label}</p>
    </div>
  );
}

export function ErrorState({ message = "Something went wrong.", onRetry, testid = "error-state" }) {
  return (
    <div data-testid={testid} className="rounded-3xl border border-rose-200 bg-rose-50/95 p-6 text-rose-800 shadow-sm">
      <div className="flex items-center gap-2 font-medium">
        <AlertTriangle className="h-5 w-5" /> {message}
      </div>
      {onRetry && (
        <button onClick={onRetry} data-testid="error-retry"
          className="mt-3 min-h-10 rounded-xl border border-rose-300 bg-white px-3 py-1.5 text-sm font-medium text-rose-700 hover:bg-rose-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-rose-500 focus-visible:ring-offset-2">
          Try again
        </button>
      )}
    </div>
  );
}

export function PermissionDeniedState({ message = "You do not have permission to view this.", testid = "permission-denied-state" }) {
  return (
    <div data-testid={testid} className="rounded-3xl border border-amber-200 bg-amber-50/95 p-6 text-amber-800 shadow-sm">
      <div className="flex items-center gap-2 font-medium">
        <AlertTriangle className="h-5 w-5" /> {message}
      </div>
    </div>
  );
}

export function EmptyState({ icon: Icon = Inbox, title, description, action, testid = "empty-state" }) {
  return (
    <div data-testid={testid}
      className="tp-paper flex flex-col items-center justify-center rounded-[2rem] border-2 border-dashed border-[#E5B85C]/45 p-12 text-center">
      <div className="mb-4 rounded-full bg-[#E5B85C]/20 p-4">
        <Icon className="h-7 w-7 text-[#2D7A65]" />
      </div>
      <h3 className="text-base font-semibold text-[#1A2420]">{title}</h3>
      {description && <p className="mt-1 max-w-sm text-sm text-slate-500">{description}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
